import { useContext } from 'react'
import styled from 'styled-components'
import { STEP } from '.'
import { CreationToolsContext } from '../../manager'
import { CreationToolSourceFile } from '../../types'
import CreationTool from '../../types/creation-tool'
import CreationToolGradient from '../../types/gradient'
import CreationToolOutputType from '../../types/output-type'
import CreationToolUserRestriction from '../../types/user-restriction'
import { GradientButton } from '../buttons'
import ContinueButton from '../continue-button'
import { GifIcon, VideoIcon } from '../icons'

const Container = styled.div`
    display: flex;
    width: 100%;

    ${GradientButton} svg {
        display: inline-block;
        height: 20px;
        margin-right: 10px;
        margin-top: -2px;
        vertical-align: middle;
    }
`

const SecondaryButton = styled(ContinueButton)`
    margin-right: 10px;
`

type Props = {
    source: CreationToolSourceFile
    disabled?: boolean
    onBeforeContinue: (outputType?: CreationToolOutputType) => Promise<void>
}

const CreationToolsVideoTrimButtons = ({ source, disabled, onBeforeContinue }: Props) => {
    const { tool, userRestrictionAccess } = useContext(CreationToolsContext)
    const { hasAudio, isUrl } = source
    const canUploadVideo = userRestrictionAccess.indexOf(CreationToolUserRestriction.CanUploadVideo) > -1
    const isGifMaker = tool === CreationTool.GifMaker

    if (canUploadVideo && hasAudio && isUrl && !isGifMaker) {
        return (
            <Container>
                <SecondaryButton
                    {...{
                        gaEventAction: STEP,
                        active: !disabled,
                        gradient: CreationToolGradient.IndigoBlue,
                        preNavigateAction: () => onBeforeContinue(CreationToolOutputType.Gif),
                    }}
                >
                    <GifIcon /> Continue as {CreationToolOutputType.title(CreationToolOutputType.Gif)}
                </SecondaryButton>
                <ContinueButton
                    {...{
                        gaEventAction: STEP,
                        active: !disabled,
                        preNavigateAction: () => onBeforeContinue(CreationToolOutputType.Video),
                    }}
                >
                    <VideoIcon /> Continue as {CreationToolOutputType.title(CreationToolOutputType.Video)}
                </ContinueButton>
            </Container>
        )
    }

    return (
        <ContinueButton
            {...{
                gaEventAction: STEP,
                active: !disabled,
                preNavigateAction: onBeforeContinue,
            }}
        />
    )
}

export default CreationToolsVideoTrimButtons
